
import { toPinyinSync, capitalizePinyin } from "./pinyinUtil";
import { apiFetch } from "./wkCommon";
import { fetchLunarForIntDate } from "./wkCommon";

export async function buildInitialAgendaAttributes(agenda) {

  let lunarInfo = null;

  if (agenda?.agendaDate) {
    try {
      lunarInfo = await fetchLunarForIntDate(agenda.agendaDate);
    } catch (e) {
      lunarInfo = null;
    }
  }

  const areaShort = agenda?.area?.shortname || "";

  const areaNameId = capitalizePinyin(
    toPinyinSync(areaShort)
  );

  const baseDate = agenda?.agendaDate;

  const d = new Date(baseDate);

  const agendaDateText =
    `西元${d.getFullYear()}年${String(d.getMonth()+1).padStart(2,"0")}月${String(d.getDate()).padStart(2,"0")}日`;

  const lunarDate = lunarInfo
    ? `歲次${lunarInfo.lunarGanZhi}${lunarInfo.leapMonth?"閏":""}${lunarInfo.lunarMonth}月${lunarInfo.lunarDay}日`
    : "";

  const resp = await apiFetch("/api/agenda-book-report-templates");

  const templates = resp?.data || [];

  const defTemplate =
    templates.find(t=>t.isDefault) || templates[0];

  const sections = defTemplate?.configJson?.sections || [];

  const getTitle = (key,defZh,defId)=>{

    const s = sections.find(x=>x.key===key);

    return {
      zh: s?.titleZh || defZh,
      id: s?.titleId || defId
    };

  };

  const rundown = getTitle("rundown","流程表","Jadwal Susunan Acara");
  const personnel = getTitle("personnel","辦事人員表","Daftar Petugas");
  const finance = getTitle("finances","收支表","Laporan Kelas");

  return {

    reportTemplateId: defTemplate?.documentId || "",

    agendaDate: baseDate,
    agendaDateText,

    lunarDate,

    areaNameZh: areaShort,
    areaNameId,

    agendaSubjectZh: agenda?.subject_zh || "",
    agendaSubjectId: agenda?.subject || "",

    rundownSectionTitleZh: rundown.zh,
    rundownSectionTitleId: rundown.id,

    personnelSectionTitleZh: personnel.zh,
    personnelSectionTitleId: personnel.id,

    financeSectionTitleZh: finance.zh,
    financeSectionTitleId: finance.id

  };

}

 	function mergeAgendaPersonnels(existing = [], incoming = []) {

  if (!Array.isArray(existing)) existing = [];
  if (!Array.isArray(incoming)) incoming = [];

    // cari group 普通 dari existing
    const existingGeneral = existing.find(g => g.Label_zh === "普通");

    const result = incoming.map(group => {

      // kalau bukan 普通 → ambil template full
      if (group.Label_zh !== "普通") return group;

      // kalau existing tidak ada → ambil template
      if (!existingGeneral) return group;

      const protectedLabels = ["操持", "聖歌", "授課"];

      const existingRoles = existingGeneral.ServiceRole || [];
      const incomingRoles = group.ServiceRole || [];

      // hasil akhir serviceRole
      const mergedRoles = incomingRoles.map(inRole => {

        // jika termasuk yang harus diproteksi
        if (protectedLabels.includes(inRole.Label_zh)) {

          const old = existingRoles.find(r => r.Label_zh === inRole.Label_zh);

          // kalau ada di existing → pakai existing (JANGAN override)
          if (old) return old;
        }

        // selain itu → pakai template
        return inRole;
      });

      // ⚠️ penting: juga preserve role lama yang TIDAK ADA di template
      const extraExistingRoles = existingRoles.filter(r =>
        !incomingRoles.some(ir => ir.Label_zh === r.Label_zh)
      );

      return {
        ...group,
        ServiceRole: [...mergedRoles, ...extraExistingRoles]
      };
    });
    // 🔥 FIX UTAMA: jika template tidak punya 普通 → tambahkan dari existing
    const hasGeneral = incoming.some(g => g.Label_zh === "普通");

    if (!hasGeneral && existingGeneral) {
      result.push(existingGeneral);
    }

    return result;
        
  }

	/* ================= SAVE TEMPLATE ================= */
	export  async function handleSaveTemplateUtil({
		saveMode,
		selectedTemplateId,
		templateZh,
		templateId,
		agendaBook,
		setShowSaveModal,
		isZh
	}) {

    if (saveMode === "new") {

      if (!templateZh || !templateId) {
        alert(isZh() ? "請填寫名稱" : "Nama template wajib diisi.");
        return;
      }

      await apiFetch("/api/agenda-book-templates", {
        method: "POST",
        body: {
          data: {
            subject_zh: templateZh,
            subject_id: templateId,
            templateAttributes: agendaBook?.agendaAttributes || {},
            templateRundowns: agendaBook?.agendaRundowns || [],
            templatePersonnels: agendaBook?.agendaPersonnels || [],
            templateFinances: agendaBook?.agendaFinances || []
          }
        }
      });

      alert(isZh() ? "範本保存成功" : "Template berhasil disimpan.");
    }

    if (saveMode === "replace") {

      if (!selectedTemplateId) {
        alert(isZh() ? "請選擇範本" : "Pilih template terlebih dahulu.");
        return;
      }

      const confirmMsg = isZh()
        ? "確定覆蓋此範本？此操作將永久修改範本內容。"
        : "Yakin ingin mengganti template ini? Data lama akan tertimpa.";

      if (!window.confirm(confirmMsg)) return;

      await apiFetch(`/api/agenda-book-templates/${selectedTemplateId}`, {
        method: "PUT",
        body: {
          data: {
            templateAttributes: agendaBook?.agendaAttributes || {},
            templateRundowns: agendaBook?.agendaRundowns || [],
            templatePersonnels: agendaBook?.agendaPersonnels || [],
            templateFinances: agendaBook?.agendaFinances || []
          }
        }
      });

      alert(isZh() ? "範本更新成功" : "Template berhasil diperbarui.");
    }

    setShowSaveModal(false);
  }

	export  async function handleLoadTemplateUtil({
			selectedTemplateId,
			templates,
			agendaBook,
			setAgendaBook,
			setShowLoadModal,
			isZh
		}) {
  
      if (!selectedTemplateId) {
        alert(isZh() ? "請選擇範本" : "Pilih template terlebih dahulu.");
        return;
      }
  
      const confirmMsg = isZh()
        ? "載入範本將覆蓋目前所有資料，是否繼續？"
        : "Load template akan menimpa semua data. Lanjutkan?";
  
      if (!window.confirm(confirmMsg)) return;
  
      const template = templates.find(t => t.documentId === selectedTemplateId);
      if (!template) return;
  
      const existingObj = agendaBook?.agendaPersonnels || {};
      const incomingObj = template.templatePersonnels || {};

      const mergedGroupRole = mergeAgendaPersonnels(
        existingObj.GroupRole || [],
        incomingObj.GroupRole || []
      );

      const mergedPersonnels = {
        ...incomingObj,
        GroupRole: mergedGroupRole
      };
  
      await apiFetch(`/api/agenda-books/${agendaBook.documentId}`, {
        method: "PUT",
        body: {
          data: {
            agendaRundowns: template.templateRundowns || [],
            agendaPersonnels: mergedPersonnels,
            agendaFinances: template.templateFinances || []
          }
        }
      });
  
      const fresh = await apiFetch(
        `/api/agenda-books/${agendaBook.documentId}?populate=*`
      );
  
      setAgendaBook(fresh?.data || fresh);
  
      alert(isZh() ? "範本載入成功" : "Template berhasil dimuat.");
  
      setShowLoadModal(false);
    }